import React from 'react';
import { Icons } from '../EpcrIcons';
import { TextField, OptionField, AutoField, DateTimeField, Section, ViewLayout } from '../EpcrFields';

export function EpcrViewNarrative() {
  const sections = [
    { id: "impression", label: "Clinical Impression" },
    { id: "signs", label: "Signs / Symptoms" },
    { id: "times", label: "Times" },
    { id: "complaint", label: "Patient Complaint" },
    { id: "injuries", label: "Injuries" },
    { id: "factors", label: "Factors Affecting Care" },
    { id: "transport", label: "Patient Transport" },
    { id: "narrative", label: "Narrative" },
  ];

  return (
    <ViewLayout sections={sections}>

      <Section id="impression" num="01" title="Clinical Impression" meta="eSituation.11–12">
        <div className="fgrid">
          <div className="fcol-6">
            <OptionField label="Primary Impression" elem="eSituation.11" required />
          </div>
          <div className="fcol-6">
            <AutoField label="Secondary Impressions" elem="eSituation.12" />
          </div>
          <div className="fcol-12">
            <OptionField label="Primary Symptom" elem="eSituation.09" />
          </div>
        </div>
      </Section>

      <Section id="signs" num="02" title="Supporting Signs / Symptoms" meta="eSituation.10">
        <AutoField label="Other Associated Symptoms" elem="eSituation.10" />
      </Section>

      <Section id="times" num="03" title="Onset & Discovery Times" meta="eSituation.01 · 18">
        <div className="fgrid">
          <div className="fcol-6"><DateTimeField label="Possible Symptom Onset Date/Time" elem="eSituation.01" /></div>
          <div className="fcol-6"><DateTimeField label="Last Known Well Date/Time" elem="eSituation.18" /></div>
        </div>
      </Section>

      <Section id="complaint" num="04" title="Patient Complaint" meta="eSituation.PatientComplaintGroup">
        <div className="fgrid">
          <div className="fcol-12">
            <TextField label="Chief Complaint (free text)" elem="eSituation.04" multiline rows={3} />
          </div>
          <div className="fcol-4">
            <TextField label="Duration of Complaint" elem="eSituation.05" placeholder="e.g. 12" />
          </div>
          <div className="fcol-4">
            <OptionField label="Time Units" elem="eSituation.06" />
          </div>
          <div className="fcol-4">
            <OptionField label="Complaint Type" elem="eSituation.03" />
          </div>
        </div>
      </Section>

      <Section id="injuries" num="05" title="Injuries" meta="eInjury.*">
        <div className="fgrid">
          <div className="fcol-6">
            <OptionField label="Mechanism / Cause of Injury" elem="eInjury.01" />
          </div>
          <div className="fcol-6">
            <OptionField label="Trauma Triage Criteria" elem="eInjury.03" />
          </div>
          <div className="fcol-12">
            <TextField label="Injury Details" path="eInjury/eInjury.Notes" multiline rows={3} />
          </div>
        </div>
      </Section>

      <Section id="factors" num="06" title="Factors Affecting Care" meta="eScene · eHistory">
        <div className="fgrid">
          <div className="fcol-12">
            <TextField label="Other Factors" path="eSituation/eSituation.Factors" multiline rows={3} />
          </div>
        </div>
      </Section>

      <Section id="transport" num="07" title="Patient Transport" meta="eDisposition.transport">
        <div className="fgrid">
          <div className="fcol-6">
            <OptionField label="Level of Care Provided per Protocol" elem="eDisposition.32" />
          </div>
          <div className="fcol-6">
            <OptionField label="Reason for Choosing Destination" elem="eDisposition.20" />
          </div>
        </div>
      </Section>

      <Section id="narrative" num="08" title="Provider Narrative" meta="eNarrative.01">
        <div className="fgrid">
          <div className="fcol-12">
            {/* <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
              <button className="btn-secondary"><Icons.note size={14} /> Template</button>
              <button className="btn-secondary"><Icons.pen size={14} /> CHART format</button>
              <button className="btn-secondary"><Icons.bolt size={14} /> SOAP format</button>
            </div> */}
            <TextField label="Narrative" elem="eNarrative.01" multiline rows={14} />
          </div>
        </div>
      </Section>

    </ViewLayout>
  );
}
